"use strict";

angular.module("prisma")
  .controller("WeatherCtrl", function ($scope) {
      var self = this;
      self.section = "Inicio";
      self.name = "An�lisis del clima";
  });
